module.exports = __webpack_public_path__ + "static/media/share_person8.3ce932bc.png";